<div class="col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 mb-4">
  <a appBackButton class="hyperlink">Back</a>
</div>

<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
  <mat-card-header>
    <a *ngIf="growerPropertyInfo && !growerPropertyInfo.managerOnly" [href]="this.dataService.loginToHort360GrowerLink(growerPropertyInfo?.growerId)" target="_blank"
       matTooltip="Login to Hort360" style="position: absolute; right: 10px; top: 5px;" mat-raised-button color="accent"><mat-icon>login</mat-icon>&nbsp;&nbsp; Login</a>
    <mat-card-title>
      <mat-icon>grass</mat-icon> {{ propertySummary ? propertySummary.name || propertySummary.growerDescription : '' }} <ng-container *ngIf="growerPropertyInfo && growerPropertyInfo.managerOnly">(Manager Only User)</ng-container>
    </mat-card-title>
    <mat-card-subtitle>
      <h1 class="m-0">{{ propertySummary ? propertySummary.address : '' }}</h1>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content *ngIf="growerPropertyInfo">
    <mat-expansion-panel class="mt-2">
      <mat-expansion-panel-header>
        <mat-icon>phone</mat-icon><h3 class="m-0 ml-2">Property / Grower Info</h3>
      </mat-expansion-panel-header>
      <h5 class="mb-1 d-inline-block">Grower / Property Id:</h5> {{ growerPropertyInfo.growerId }} / {{ growerPropertyInfo.propertyId }}<br/>
      <ng-container *ngIf="growerPropertyInfo.phone">
        <h5 class="mb-1 d-inline-block">Phone:</h5> {{ growerPropertyInfo.phone }}<br/>
      </ng-container>
      <ng-container *ngIf="growerPropertyInfo.mobile">
        <h5 class="mb-1 d-inline-block">Mobile:</h5> {{ growerPropertyInfo.mobile }}<br/>
      </ng-container>
      <ng-container *ngIf="growerPropertyInfo.emailaddress">
        <h5 class="mb-1 d-inline-block">Email:</h5> {{ growerPropertyInfo.emailaddress }}<br/>
      </ng-container>
      <ng-container *ngIf="propertySummary.address">
        <h5 class="mb-1 d-inline-block">Address:</h5> {{ propertySummary.address }}<br/>
      </ng-container>
      <ng-container *ngIf="growerPropertyInfo.abn">
        <h5 class="mb-1 d-inline-block">ABN:</h5> {{ growerPropertyInfo.abn }}<br/>
      </ng-container>
      <ng-container *ngIf="growerPropertyInfo.company">
        <h5 class="mb-1 d-inline-block">Company:</h5> {{ growerPropertyInfo.company }}<br/>
      </ng-container>
      <ng-container *ngIf="growerPropertyInfo.crops">
        <h5 class="mb-1 d-inline-block">Crop/s:</h5> {{ getPropertyCropsString() }}<br/>
      </ng-container>
      <ng-container *ngIf="growerPropertyInfo.area">
        <h5 class="mb-1 d-inline-block">Property Ha:</h5> {{ growerPropertyInfo.area}}<br/>
      </ng-container>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-icon>verified_user</mat-icon><h3 class="m-0 ml-2">Reef Certification</h3>
      </mat-expansion-panel-header>

      <h5 class="mb-1 d-inline-block">Reef Certification:</h5> {{ growerPropertyInfo.reefCertDate ? growerPropertyInfo.reefCertDate : 'None' }}<br/>
      <ng-container *ngFor="let item of growerReefCertifiedItems | async; let index = index">
        <hr/>
        <h5 class="mb-1 d-inline-block">Recertification {{ index + 1 }}:</h5>
        {{ item.date }}
        <button (click)="editPropertyReefCertifiedDate(item.id)" mat-icon-button color="primary"><mat-icon>arrow_upward</mat-icon></button>
        <button (click)="deletePropertyReefCertifiedDate(item.id)" mat-icon-button color="warn"><mat-icon>clear</mat-icon></button>
        <br/>
      </ng-container>

      <br/>
      <mat-form-field appearance="fill" floatLabel="always" style="width: 320px; display: inline-block;">
        <mat-label>Add certification / recertification date</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="growerReefCertifiedDate" rsValid="required">
        <mat-datepicker-toggle matSuffix [for]="picker">
          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <button matSuffix mat-icon-button color="accent" class="ml-1" style="display: inline-block;" (click)="$event.stopPropagation(); $event.preventDefault(); addPropertyReefCertifiedDate(growerReefCertifiedDate)">
          <mat-icon>add</mat-icon>
        </button>
      </mat-form-field>

    </mat-expansion-panel>
  </mat-card-content>
</mat-card>

<ng-container *ngIf="!growerPropertyInfo">
  <mat-spinner
    diameter="40"
    class="ml-auto mr-auto d-block mt-50 mb-25" color="primary"></mat-spinner>
  <br/>
</ng-container>

<ng-container *ngIf="growerPropertyInfo">

  <mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>question_answer</mat-icon> Property interactions
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <br/>
      <h2>Workshops & Field Days</h2>

      <mat-list class="odd-even-list">
        <ng-container *ngFor="let event of dataService.events | async">
          <mat-list-item *ngIf="growerEventIds.indexOf(event.id) !== -1" class="row mr-0 ml-0">
            <div class="d-flex w-100">
              <span class="ellipsis clickable" style="line-height: 42px; font-size: medium"  (click)="launchEvent(event)">
                {{ event.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} - {{ event.name }}
              </span>

              <div class="flex-grow-1"></div>

              <app-category-tag class="align-self-end" style="margin-bottom: 5px;" [category]="event.category"></app-category-tag>

              <button class="align-self-end" mat-icon-button [matMenuTriggerFor]="eventMenu" [matMenuTriggerData]="{event: event}"><mat-icon>more_vert</mat-icon></button>
            </div>
          </mat-list-item>
        </ng-container>
      </mat-list>

      <br/>
      <div>
        <mat-form-field appearance="fill" floatLabel="always" style="width: 320px; display: inline-block;">
          <mat-label>Add to event: </mat-label>
          <mat-select [(ngModel)]="selectEvent">
            <mat-option [value]="event.id" *ngFor="let event of dataService.events | async">{{ event.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} - {{ (event.category | resolveCategory).name }} - {{ event.name }}</mat-option>
          </mat-select>
          <button matSuffix mat-icon-button color="accent" class="ml-1" (click)="$event.stopPropagation(); $event.preventDefault(); addPropertyToEvent(selectEvent)">
            <mat-icon>add</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>
      <br/><br/>

      <h2>Meetings</h2>
      <mat-list class="odd-even-list">
        <ng-container *ngFor="let meeting of dataService.meetings | async">
          <mat-list-item *ngIf="growerMeetingIds.indexOf(meeting.id) !== -1" class="row mr-0 ml-0">
            <div class="d-flex w-100">
              <span class="ellipsis clickable" style="line-height: 42px; font-size: medium"  (click)="launchMeeting(meeting)">
                {{ meeting.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} - {{ meeting.topic }}
              </span>
              <div class="flex-grow-1"></div>
              <button class="align-self-end" mat-icon-button [matMenuTriggerFor]="meetingtMenu" [matMenuTriggerData]="{meeting: meeting}"><mat-icon>more_vert</mat-icon></button>
            </div>
          </mat-list-item>
        </ng-container>
      </mat-list>

      <br/>
      <div>
        <mat-form-field appearance="fill" floatLabel="always" style="width: 320px; display: inline-block;">
          <mat-label>Add to meeting: </mat-label>
          <mat-select [(ngModel)]="selectMeeting">
            <mat-option [value]="meeting.id" *ngFor="let meeting of dataService.meetings | async">{{ meeting.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }}- {{ meeting.topic }}</mat-option>
          </mat-select>
          <button matSuffix mat-icon-button color="accent" class="ml-1" (click)="$event.stopPropagation(); $event.preventDefault(); addPropertyToMeeting(selectMeeting)">
            <mat-icon>add</mat-icon>
          </button>
        </mat-form-field>
      </div>



      <mat-divider></mat-divider>
      <br/><br/>


      <h2>Assistance Provided</h2>

      <mat-list class="odd-even-list mb-2" *ngIf="growerAssistance.length > 0">
        <ng-container *ngFor="let assistance of growerAssistance">
          <mat-list-item style="height: auto;">
            <div class="d-flex w-100 flex-nowrap">
              <div class="flex-grow-1 w-100 d-flex flex-wrap w-100 align-content-end align-items-end">
                <span class="ellipsis clickable" style="line-height: 42px; font-size: medium" (click)="openAssistance(assistance)">
                  {{ assistance.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} - {{ (assistance.type | resolveAssistanceType).name }}
                  <ng-container *ngIf="assistance.flagged">
                    &nbsp;&nbsp;<mat-icon style="vertical-align: middle;" color="primary" matTooltip="Follow-up required">flag</mat-icon>
                  </ng-container>
                </span>

                <div class="flex-grow-1"></div>

                <app-category-tag *ngFor="let tag of assistance.categories" [category]="tag" class="mr-2 mb-1 mt-1 align-self-end"></app-category-tag>
              </div>
              <div class="text-right">
                <button mat-icon-button [matMenuTriggerFor]="assistanceMenu" [matMenuTriggerData]="{assistance: assistance}"><mat-icon>more_vert</mat-icon></button>
              </div>
            </div>
          </mat-list-item>
        </ng-container>
      </mat-list>

      <div>
        <mat-form-field appearance="fill" floatLabel="always" style="width: 320px; display: inline-block;">
          <mat-label>Add assistance: </mat-label>
          <mat-select [(ngModel)]="selectAssistance">
            <mat-option [value]="assistance.id" *ngFor="let assistance of dataService.assistanceProvidedTypes | async">{{ assistance.name }} - {{ (assistance.category | resolveCategory).name }} </mat-option>
          </mat-select>
          <button matSuffix mat-icon-button color="accent" class="ml-1" (click)="$event.stopPropagation(); $event.preventDefault(); addAssistance(selectAssistance)">
            <mat-icon>add</mat-icon>
          </button>
        </mat-form-field>
      </div>



      <mat-divider></mat-divider>
      <br/><br/>






      <h2>Practice Change</h2>

      <mat-list class="odd-even-list mb-2" *ngIf="growerPracticeChanges.length > 0">
        <ng-container *ngFor="let practiceChange of growerPracticeChanges">
          <mat-list-item style="height: auto;">
            <div class="d-flex w-100 flex-nowrap">
              <div class="flex-grow-1 w-100 d-flex flex-wrap w-100 align-content-end align-items-end">
                <span class="ellipsis clickable" style="line-height: 42px; font-size: medium" (click)="openPracticeChange(practiceChange)">
                  {{ practiceChange.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} - {{ (practiceChange.activity | resolvePracticeChangeActivity).name }}
                </span>

                <div class="flex-grow-1"></div>

                <app-category-tag [category]="practiceChange.category" class="mr-2 mb-1 mt-1 align-self-end"></app-category-tag>
              </div>
              <div class="text-right">
                <button mat-icon-button [matMenuTriggerFor]="practiceChangeMenu" [matMenuTriggerData]="{practiceChange: practiceChange}"><mat-icon>more_vert</mat-icon></button>
              </div>
            </div>
          </mat-list-item>
        </ng-container>
      </mat-list>

      <div>
        <button mat-raised-button color="primary" (click)="$event.stopPropagation(); $event.preventDefault(); addPracticeChange()">
          <mat-icon>add</mat-icon> &nbsp;Add new
        </button>
      </div>

      <br/><br/>



      <mat-divider></mat-divider>
      <br/><br/>







      <h2>Extension Contact</h2>

      <mat-list class="odd-even-list mb-2" *ngIf="growerContacts.length > 0">
        <ng-container *ngFor="let activity of growerContacts">
          <mat-list-item style="height: auto;">
            <div class="d-flex w-100 flex-nowrap">
              <div class="flex-grow-1 w-100 d-flex flex-wrap w-100 align-content-end align-items-end">
                <span class="ellipsis clickable" style="line-height: 42px; font-size: medium" (click)="openContact(activity)">
                  {{ activity.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} - {{ activity.type | camelConvert }}
                  <ng-container *ngIf="activity.flagged">
                    &nbsp;&nbsp;<mat-icon style="vertical-align: middle;" color="primary" matTooltip="Follow-up required">flag</mat-icon>
                  </ng-container>
                </span>

                <div class="flex-grow-1"></div>

                <app-category-tag *ngFor="let tag of activity.categories" [category]="tag" class="mr-2 mb-1 mt-1 align-self-end"></app-category-tag>
              </div>
              <div class="text-right">
                <button mat-icon-button [matMenuTriggerFor]="contactMenu" [matMenuTriggerData]="{activity: activity}"><mat-icon>more_vert</mat-icon></button>
              </div>
            </div>
          </mat-list-item>
        </ng-container>
      </mat-list>

      <div>
        <mat-form-field appearance="fill" floatLabel="always" style="width: 320px; display: inline-block;">
          <mat-label>Add contact: </mat-label>
          <mat-select [(ngModel)]="selectContact">
            <mat-option [value]="contact" *ngFor="let contact of contactTypes">{{ contact | camelConvert }}</mat-option>
          </mat-select>
          <button matSuffix mat-icon-button color="accent" class="ml-1" (click)="$event.stopPropagation(); $event.preventDefault(); addContact(selectContact)">
            <mat-icon>add</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <br/><br/>

    </mat-card-content>
  </mat-card>
</ng-container>





<!-- Menu eventMenu -->
<mat-menu #eventMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent let-event="event">
    <button mat-menu-item (click)="launchEvent(event)">
      <mat-icon>launch</mat-icon>
      <span>View event</span>
    </button>
    <button mat-menu-item (click)="removeFromEvent(event)">
      <mat-icon>delete</mat-icon>
      <span>Remove from event</span>
    </button>
  </ng-template>
</mat-menu>

<!-- Menu meetingMenu -->
<mat-menu #meetingtMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent let-meeting="meeting">
    <button mat-menu-item (click)="launchMeeting(meeting)">
      <mat-icon>launch</mat-icon>
      <span>View meeting</span>
    </button>
    <button mat-menu-item (click)="removeFromMeeting(meeting)">
      <mat-icon>delete</mat-icon>
      <span>Remove from meeting</span>
    </button>
  </ng-template>
</mat-menu>


<!-- Menu assistanceMenu -->
<mat-menu #assistanceMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent let-assistance="assistance">
    <button mat-menu-item (click)="openAssistance(assistance)">
      <mat-icon>open</mat-icon>
      <span>View assistance Provided</span>
    </button>
    <button mat-menu-item (click)="removeAssistance(assistance)">
      <mat-icon>delete</mat-icon>
      <span>Remove assistance provided</span>
    </button>
  </ng-template>
</mat-menu>


<!-- Menu practiceChangeMenu -->
<mat-menu #practiceChangeMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent let-practiceChange="practiceChange">
    <button mat-menu-item (click)="openPracticeChange(practiceChange)">
      <mat-icon>open</mat-icon>
      <span>View Practice Change</span>
    </button>
    <button mat-menu-item (click)="removePracticeChange(practiceChange)">
      <mat-icon>delete</mat-icon>
      <span>Remove Practice Change</span>
    </button>
  </ng-template>
</mat-menu>


<!-- Menu contactMenu -->
<mat-menu #contactMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent let-activity="activity">
    <button mat-menu-item (click)="openContact(activity)">
      <mat-icon>open_in_full</mat-icon>
      <span>Open</span>
    </button>
    <button mat-menu-item (click)="removeContact(activity)">
      <mat-icon>delete</mat-icon>
      <span>Remove contact</span>
    </button>
  </ng-template>
</mat-menu>
